import { Injector } from '@angular/core';
import { fabric } from 'fabric';
import { ItemModel } from '../../../../models/itemModel';
import { FrameItem } from '../../../../models/session';
import { RemoteVideoItemCanvasComponent } from '../../remote-video-item-canvas/remote-video-item-canvas.component';
import { BoardItemComponentClass, FabricControls } from './board.item';
import { BoardRemoteVideoConfigurations } from './board-remote-video-configurations';
import { CreationContext } from './board-item-configurations';

// Hide all rotation controls and middle controls for remote videos
const RemoteVideoInvisibleControls = [
  FabricControls.MiddleTop,
  FabricControls.MiddleBottom,
  FabricControls.MiddleLeft,
  FabricControls.MiddleRight,
  FabricControls.RotateBottomLeft1,
  FabricControls.RotateBottomLeft2,
  FabricControls.RotateBottomRight1,
  FabricControls.RotateBottomRight2,
  FabricControls.RotateTopLeft1,
  FabricControls.RotateTopLeft2,
  FabricControls.RotateTopRight1,
  FabricControls.RotateTopRight2,
];

export class BoardRemoteVideo extends BoardItemComponentClass<
  BoardRemoteVideoConfigurations,
  RemoteVideoItemCanvasComponent
>(fabric.Rect) {
  AngularComponentClass = RemoteVideoItemCanvasComponent;

  constructor(
    injector: Injector,
    configurations: BoardRemoteVideoConfigurations,
    creationContext: CreationContext,
  ) {
    super(
      injector,
      ItemModel.RemoteVideo,
      configurations,
      RemoteVideoInvisibleControls,
      creationContext,
    );
    this.hasRotatingPoint = false;
  }

  protected onFabricAdded() {
    super.onFabricAdded();

    // Making it at the top as soon as we add it to the space
    this.canvas?.setActiveObject?.(this);
  }

  bindAngularComponentInputs(): void {
    if (!this.componentRef) {
      return;
    }

    this.componentRef.setInput('state', this.configurations);
    this.componentRef.changeDetectorRef.detectChanges();
  }

  override toFrameItem(): FrameItem {
    const encodedBoardItem = super.toFrameItem();
    return {
      ...encodedBoardItem,
      model: ItemModel.RemoteVideo,
      content_id: this.getContentId(),
    };
  }

  override openLock() {
    this.lockMovementX = false;
    this.lockMovementY = false;
    this.lockRotation = true;
    this.lockScalingX = false;
    this.lockScalingY = false;
    this.lockUniScaling = true;
    this.lockSkewingX = true;
    this.lockSkewingY = true;
    this.lockScalingFlip = false;
  }

  public getContentId() {
    return `${this.configurations.participantId}:${this.configurations.trackType}`;
  }
}
